module.exports = __webpack_public_path__ + "0aa843716d9ec3f2da32058ae2d91e92.MP3";